import { DialogsModule } from '@progress/kendo-angular-dialog';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CaseEnrollmentComponent } from './case-enrollment.component';
import { PopupModule } from '@progress/kendo-angular-popup';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ButtonModule, ButtonsModule, DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
    imports: [
        CommonModule,
        DialogsModule,
        PopupModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        InputsModule,
        LabelModule,
        DropDownsModule,
        LayoutModule,
        PipesModule,
        ButtonModule,
        DropDownButtonModule,
        ButtonsModule,
    ],
    declarations: [
        CaseEnrollmentComponent
    ],
    exports: [
        CaseEnrollmentComponent
    ]
})
export class CaseEnrollmentModule { }
